exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlDeleteLinkModal[data-v-30e02b2a] {\n  padding: 1rem;\n}\n.vlDeleteLinkModal h3[data-v-30e02b2a] {\n  margin-bottom: 1rem;\n}\n.vlDeleteLinkModal button[data-v-30e02b2a] {\n  width: 10rem;\n}\n.vlDeleteLinkModal > div[data-v-30e02b2a] {\n  width: 21rem;\n  display: flex;\n  justify-content: space-between;\n}", ""]);

// exports
